/**
 * Auto-generated version file from package.json
 * DO NOT EDIT DIRECTLY - Use npm run generate-version
 */

export const VERSION = '2.1.12';
export const VERSION_INFO = {
  version: '2.1.12',
  name: 'bitwrench',
  license: 'BSD-2-Clause',
  buildDate: '2026-10-31'
};
